import { render } from "./MainGDPR.vue?vue&type=template&id=40f5f988&scoped=true"
import script from "./MainGDPR.vue?vue&type=script&lang=js"
export * from "./MainGDPR.vue?vue&type=script&lang=js"

import "./MainGDPR.vue?vue&type=style&index=0&id=40f5f988&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f5f988"]])

export default __exports__